'use strict';

const ajax = require('./modules/ajax');
const scrollHelper = require('./modules/helpers/scroll');

function initEvents() {
    if (this.initialized) {
        return;
    }

   genericFlyout.$closeFlyouts.on('keyup', function(e){
        if (e.which == 13) {
           closeFlyouts();
        }
    });

    $(document).on('keyup', function(e) {
        if (e.which !== 27) {
            return;
        }
        closeFlyouts();
   });

   this.initialized = true;

}

function open(params) {
    genericFlyout.def.$genericFlyout.addClass('open');

    handleAccessibility();

    genericFlyout.def.$modalOverlay.fadeIn();

    scrollHelper.disableScroll();

    if (params.open) {
        params.open();
    }

    if (params.close) {
        genericFlyout.def.$genericFlyout.off('closeFlyout');
        genericFlyout.def.$genericFlyout.on('closeFlyout', function () {
            params.close();
        });
    }

    genericFlyout.def.$closeButton.prependTo(genericFlyout.def.$flyoutContent);
}

function closeFlyouts(){
    genericFlyout.def.$genericFlyout.removeClass('open');
    const openedFlyout = $('.js-flyout-opened');
    openedFlyout.focus();
    setTimeout(function() {
        openedFlyout.removeClass('js-flyout-opened');
    },400);

    genericFlyout.def.$genericFlyout.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '-1');

    genericFlyout.def.$modalOverlay.fadeOut();

    scrollHelper.enableScroll();

    genericFlyout.def.$genericFlyout.trigger('closeFlyout');
}

function handleAccessibility() {
    genericFlyout.def.$genericFlyout.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '0');
    $('.js-genericflyout-skip-to-content', genericFlyout.def.$genericFlyout).focus();
}

function load(options){
    ajax.load({
        url: options.url,
        target: genericFlyout.def.$flyoutContent,
        callback: function () {
            open(options);
        }
    });
}

const genericFlyout = {
    initialized: false,
    def: {
        $modalOverlay: $('.js-modal-overlay'),
        $genericFlyout: $('.js-generic-flyout'),
        $flyoutContent: $('.js-flyout-content'),
        $closeButton: $('.js-generic-flyout .js-close-flyout')
    },
    init: initEvents.bind(this),
    load: load,
    closeFlyouts: closeFlyouts
};

module.exports = genericFlyout;
